import { Outlet, useParams, useNavigate, useLocation } from 'react-router-dom';
import { languagesAllowed } from '../../components/i18n';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next'

export const Languages = () => {
    const { language } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { i18n } = useTranslation();

    useEffect(() => {
        if (languagesAllowed.findIndex(lang => lang === language) === -1) {
            // LANGUAGE NOT ALLOWED and REDIRECT TO LOGIN
            const pathArray = location.pathname.split('/');
            pathArray[1] = process.env.REACT_APP_LANG;
            window.localStorage.i18nextLng = process.env.REACT_APP_LANG;
            navigate(pathArray.join('/'));
        } 
    }, []);

    const changeLocale = (language) => {
        const pathArray = location.pathname.split('/');
        pathArray[1] = language;
        i18n.changeLanguage(language);
        navigate(pathArray.join('/'));
    }
    
    return <Outlet />
}
